module.exports = "/_next/static/images/default-9e111ba56be6d74060ec6b163ae98804.png";